var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReturn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34.16 36.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#a8b0b5;}.cls-2{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:1.07px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.53,20.69A20.77,20.77,0,0,0,10.15,3.34h0L9.84,1.17l-4,4.22,5,3-.3-2.17A17.89,17.89,0,0,1,30.62,20.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33.53,20.69A20.77,20.77,0,0,0,10.15,3.34h0L9.84,1.17l-4,4.22,5,3-.3-2.17A17.89,17.89,0,0,1,30.62,20.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.64,11C7.58,11,1.91,16.62,1.91,22.68S7.58,34.41,13.64,34.41s11.73-5.67,11.73-11.73S19.7,11,13.64,11m0,25.37A13.64,13.64,0,1,1,27.27,22.68,13.66,13.66,0,0,1,13.64,36.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.78,18.66c-1.32.23-2.13,1-2.13,1.43s.81,1.19,2.13,1.42l.15,0V18.63Zm1.66,8,.16,0c1.19-.24,2-.94,2-1.41s-.82-1.16-2-1.4l-.16,0Zm-1.51,3.85v-1.8l-.12,0A4.06,4.06,0,0,1,9.25,26l1.51-.49a3,3,0,0,0,2,1.11l.15,0V23.49l-.11,0a6.94,6.94,0,0,1-2.53-1l-.06,0a3.14,3.14,0,0,1-1.09-2.34c0-1.75,1.51-3.18,3.67-3.47h.12V14.85h1.51v1.77l.13,0A4.13,4.13,0,0,1,17.93,19l-1.47.69a3,3,0,0,0-1.86-1l-.16,0v3.29l.12,0a8.1,8.1,0,0,1,2.37.9,2.61,2.61,0,0,1,.57.48l.13.18a2.94,2.94,0,0,1,.5,1.66c0,1.71-1.46,3.14-3.56,3.45l-.13,0v1.82Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturn);
export default __webpack_public_path__ + "static/media/return.38257a14.svg";
export { ForwardRef as ReactComponent };